import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareVersionDetailLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'software-version-detail-legacy-redirect',
	path: '/browse/:projectKey/fixforversion/:versionId',
};
